import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Form, Button, Card } from "react-bootstrap";
import { FaPrint, FaDownload, FaSearch, FaUser, FaMoneyBillWave, FaFileInvoice, FaFilter, FaPhone, FaMapMarkerAlt, FaShoppingCart } from "react-icons/fa";
import { usePagination } from "../hooks/usePagination";
import Pagination from "../Components/Pagination";
import "./CustomerList.css";
import api from "../services/api";

const CustomerWiseLedger = () => {
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    transactionType: "all",
    name: ""
  });

  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [search, setSearch] = useState("");


  // Sample customers with extended details
  const [customers, setCustomers] = useState([]);

  // Sample ledger data
  const [ledgerData, setLedgerData] = useState([]);
  const fetchDeliveryNotes = async () => {
    try {
      // setLoading(true);
      // setError("");
      const response = await api.post("/customer_ledger_report.php", {});

      if (response.data.head.code === 200) {
        setLedgerData(response.data.body);
      } else {
        // setError(response.data.head.msg || "Failed to fetch delivery notes");
        setLedgerData([]);
      }
    } catch (err) {
      console.error("Error fetching delivery notes:", err);
      // setError("Failed to load delivery notes. Please try again.");
      setLedgerData([]);
    } finally {
      // setLoading(false);
    }

    try {
      // setLoading(true);
      // setError(null);

      // Note: The customer_list.php expects JSON input, so we need to send an empty object
      const response = await api.post("/customer_list.php", {});

      if (response.data.head.code === 200) {

        setCustomers(response.data.body);
      } else {
        // setError(response.data.head.msg || "Failed to fetch customers");
      }
    } catch (err) {
      console.error("Error fetching customers:", err);
      // setError("Failed to load customers. Please try again.");
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeliveryNotes();
  }, []);

  // Filter ledger data based on selected customer and date range
  // Parse YYYY-MM-DD to Date
  const parseYYYYMMDD = (dateStr) => {
    if (!dateStr) return null;
    const [year, month, day] = dateStr.split("-");
    return new Date(year, month - 1, day);
  };

  // Parse DD-MM-YYYY to Date (if your ledger uses this format)
  const parseDDMMYYYY = (dateStr) => {
    if (!dateStr) return null;
    const [day, month, year] = dateStr.split("-");
    return new Date(year, month - 1, day);
  };

  // Filter ledger based on date range and search
  // const filteredLedger = ledgerData.filter((entry) => {
  //   console.log("search is ", search);
  //   // 🔍 Search filter
  //   const matchesSearch =
  //     !search ||
  //     entry.customer_name?.toLowerCase().includes(search.toLowerCase()) ||
  //     entry.doc_no?.toLowerCase().includes(search.toLowerCase());

  //   // 📅 Date filter
  //   const entryDate = entry.date ? parseDDMMYYYY(entry.date) : null;

  //   const from = filters.startDate ? parseYYYYMMDD(filters.startDate) : null;
  //   const to = filters.endDate ? parseYYYYMMDD(filters.endDate) : null;
  //   if (to) to.setHours(23, 59, 59, 999); // include full day

  //   const matchesDate =
  //     !entryDate || ((!from || entryDate >= from) && (!to || entryDate <= to));

  //   return matchesSearch && matchesDate;
  // });
  let runningBalance = 0;

const filteredLedger = ledgerData
  .filter((entry) => {
    const matchesSearch =
      !search ||
      entry.customer_name?.toLowerCase().includes(search.toLowerCase()) ||
      entry.doc_no?.toLowerCase().includes(search.toLowerCase());

    const entryDate = entry.date ? parseDDMMYYYY(entry.date) : null;

    const from = filters.startDate ? parseYYYYMMDD(filters.startDate) : null;
    const to = filters.endDate ? parseYYYYMMDD(filters.endDate) : null;

    if (to) to.setHours(23, 59, 59, 999);

    const matchesDate =
      !entryDate || ((!from || entryDate >= from) && (!to || entryDate <= to));

    return matchesSearch && matchesDate;
  })
  .sort((a, b) => parseDDMMYYYY(a.date) - parseDDMMYYYY(b.date))
  .map((entry) => {

    runningBalance =
      Number(runningBalance) +
      Number(entry.debit || 0) -
      Number(entry.credit || 0);

    return {
      ...entry,
      balanceCalc: runningBalance
    };
  });


  // Calculate opening balance (balance before the selected date range)
  const getOpeningBalance = () => {
    if (!selectedCustomer || !dateFrom) return 0;

    const previousEntries = ledgerData.filter(entry =>
      entry.customerId === parseInt(selectedCustomer) && entry.date < dateFrom
    );

    if (previousEntries.length === 0) return 0;

    return previousEntries[previousEntries.length - 1].balance;
  };

  // Calculate totals
  const calculateTotals = () => {
    return filteredLedger.reduce((totals, entry) => {
      return {
        totalDebit: Number(totals.totalDebit) + Number(entry.debit),
        totalCredit: Number(totals.totalCredit) + Number(entry.credit),
        closingBalance: entry.balanceCalc
      };
    }, { totalDebit: 0, totalCredit: 0, closingBalance: 0 });
  };


  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const totals = calculateTotals();
  const netBalance = totals.totalDebit - totals.totalCredit;

  const openingBalance = getOpeningBalance();

  // Custom transaction type classes using your CSS
  const getTransactionTypeClass = (type) => {
    const typeClassMap = {
      invoice: 'status-badge status-approved',
      receipt: 'status-badge status-completed',
      payment: 'status-badge status-rejected',
      credit_note: 'status-badge status-pending',
      debit_note: 'status-badge status-progress'
    };

    const labels = {
      invoice: 'Invoice',
      receipt: 'Receipt',
      payment: 'Payment',
      credit_note: 'Credit Note',
      debit_note: 'Debit Note'
    };

    return {
      className: typeClassMap[type] || 'status-badge status-default',
      label: labels[type] || type
    };
  };

  // Get selected customer details
  const getSelectedCustomer = () => {
    return customers.find(c => c.name === selectedCustomer);
  };

  const selectedCustomerDetails = getSelectedCustomer();

  // Pagination hook
  const {
    currentPage,
    totalPages,
    currentItems: currentLedger,
    handlePageChange,
    indexOfFirstItem
  } = usePagination(filteredLedger, 10);

  // const handlePrint = () => {
  //   window.print();
  // };
  const formatToDDMMYYYY = (dateStr) => {
  if (!dateStr) return "";

  const [year, month, day] = dateStr.split("-");
  return `${day}-${month}-${year}`;
};
const formatDDMMYYYY = (date) => {
  const d = String(date.getDate()).padStart(2, "0");
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const y = date.getFullYear();
  return `${d}-${m}-${y}`;
};
const getMonthStartEnd = () => {
  const now = new Date();

  const start = new Date(now.getFullYear(), now.getMonth(), 1);
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);

  return {
    from_date: formatDDMMYYYY(start),
    to_date: formatDDMMYYYY(end),
  };
};
  const handlePrint = () => {
    const fromDate = formatToDDMMYYYY(filters.startDate) || getMonthStartEnd().from_date;
  const toDate = formatToDDMMYYYY(filters.endDate) || getMonthStartEnd().to_date;

  console.log("Print From:", fromDate);
  console.log("Print To:", toDate);
  // /vinayaga_wires
    window.open(`/customerledgerprint/${search}/${fromDate}/${toDate}`, '_blank');
  };

  const handleExport = () => {
    if (!selectedCustomerDetails) return;

    const headers = ['Date', 'Type', 'Document No', 'Description', 'Debit', 'Credit', 'Balance'];
    const csvData = filteredLedger.map(entry => [
      entry.date,
      entry.type,
      entry.documentNo,
      entry.description,
      entry.debit,
      entry.credit,
      entry.balance
    ]);

    const csvContent = [headers, ...csvData]
      .map(row => row.map(cell => `"${cell}"`).join(','))
      .join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `customer-ledger-${selectedCustomerDetails.name}-${new Date().toISOString().split('T')[0]}.csv`;
    link.click();
    window.URL.revokeObjectURL(url);
  };

  const clearFilters = () => {
    setSelectedCustomer("");
    setDateFrom("");
    setDateTo("");
    setSearch("");
  };



  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Customer Wise Ledger</h2>

      {/* Filters Section */}
      <div className="filter-section mb-3 p-3 bg-light rounded shadow-sm">
        <Row className="align-items-center mb-2">
          <Col>
            <h5 className="mb-0">
              <FaFilter className="me-2" />
              Filters
            </h5>
          </Col>
        </Row>

        <Row className="g-2">
          <Col xs={12} md={3} lg={3}>
            <Form.Group>
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                type="date"
                name="startDate"
                value={filters.startDate}
                onChange={handleFilterChange}
              />
            </Form.Group>
          </Col>

          <Col xs={12} md={3} lg={3}>
            <Form.Group>
              <Form.Label>End Date</Form.Label>
              <Form.Control
                type="date"
                name="endDate"
                value={filters.endDate}
                onChange={handleFilterChange}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={4} lg={4} className="mb-2 mb-md-0">
            <div className="position-relative">
              <Form.Label>Search</Form.Label>
              <Form.Control
                placeholder="Search by Customer Name,Document No"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Escape') setSearch("");
                }}
              />
            </div>
          </Col>
          <Col xs={12} md={2} lg={2} className="mb-2 mb-md-0">
            <div className="position-relative">
              <Form.Label> Print</Form.Label>
              <Button className="btn-submit" onClick={handlePrint}>
                <FaPrint size={20} />
              </Button>
            </div>
          </Col>

          {/* <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
            <Form.Label>Search</Form.Label>
            <Form.Select
              name="worker_name"
              onChange={(e) => setSearch(e.target.value)}
            >
              <option value="">Select Customer</option>
              {customers.map((customer) => (
                <option key={customer.id} value={customer.id}>
                  {customer.name}
                </option>
              ))}
            </Form.Select>
          </Col> */}

        </Row>
      </div>

      {/* Customer Information Table */}
      {selectedCustomerDetails && (
        <div className="mb-4">
          <h5 className="mb-3">
            <FaUser className="me-2 text-primary" />
            Customer Details
          </h5>
          <div className="table-responsive">
            <Table bordered className="customer-table customer-details-table">
              <thead className="table-primary">
                <tr>
                  <th width="5%">S.No</th>
                  <th width="20%">Name</th>
                  <th width="15%">Mobile</th>
                  <th width="20%">GST Number</th>
                  <th width="15%">State</th>
                  <th width="25%">Order History</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="text-center">1</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <FaUser className="me-2 text-primary" />
                      <strong>{selectedCustomerDetails.name}</strong>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <FaPhone className="me-2 text-success" />
                      {selectedCustomerDetails.mobile}
                    </div>
                  </td>
                  <td>
                    <code>{selectedCustomerDetails.gstin}</code>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <FaMapMarkerAlt className="me-2 text-danger" />
                      {selectedCustomerDetails.state}
                    </div>
                  </td>
                  <td>
                    <div className="d-flex align-items-center">
                      <FaShoppingCart className="me-2 text-warning" />
                      <div>
                        <div>
                          <strong>{selectedCustomerDetails.totalOrders}</strong> Orders
                        </div>
                        <div className="text-muted small">
                          Total: ₹{selectedCustomerDetails.totalAmount?.toLocaleString('en-IN')}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>
      )}

      {/* Balance Summary */}
      {selectedCustomer && (
        <Row className="mb-3">
          <Col xs={12}>
            <div className="p-3 border rounded bg-light">
              <Row>
                <Col md={3}>
                  <strong>Opening Balance:</strong>
                  <span className={openingBalance >= 0 ? 'text-success' : 'text-danger'}>
                    ₹{Math.abs(openingBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    {openingBalance >= 0 ? ' Dr' : ' Cr'}
                  </span>
                </Col>
                <Col md={3}>
                  <strong>Total Debit:</strong> ₹{totals.totalDebit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </Col>
                <Col md={3}>
                  <strong>Total Credit:</strong> ₹{totals.totalCredit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                </Col>
                <Col md={3}>
                  <strong>Closing Balance:</strong>
                  <span className={totals.closingBalance >= 0 ? 'text-success' : 'text-danger'}>
                    ₹{Math.abs(totals.closingBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                    {totals.closingBalance >= 0 ? ' Dr' : ' Cr'}
                  </span>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      )}

      {/* Ledger Table */}
      <div className="table-pagination-wrapper">
        <div className="table-pagination-content">
          <h5 className="mb-3">
            <FaFileInvoice className="me-2 text-primary" />
            Ledger Transactions
          </h5>
          <Table responsive className="customer-table customer-ledger-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Customer Name</th>
                <th>Document No</th>
                {/* <th>Description</th> */}
                <th className="text-end">Debit (₹)</th>
                <th className="text-end">Credit (₹)</th>
                <th className="text-end">Balance (₹)</th>
              </tr>
            </thead>
            <tbody>
              {/* Opening Balance Row */}
              {selectedCustomer && (
                <tr className="table-warning">
                  <td colSpan="4" className="text-end fw-bold">Opening Balance</td>
                  <td colSpan="3" className="text-end fw-bold">
                    <span className={openingBalance >= 0 ? 'text-success' : 'text-danger'}>
                      ₹{Math.abs(openingBalance).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                      {openingBalance >= 0 ? ' Dr' : ' Cr'}
                    </span>
                  </td>
                </tr>
              )}

              {/* {filteredLedger.map((entry, index) => { */}
                {currentLedger.map((entry, index) => {
                const transactionType = getTransactionTypeClass(entry.type);
                console.log("saadgdgad ", entry);
                return (
                  <tr key={entry.id}>
                    <td className="text-center">{entry.date}</td>
                    <td className="text-left">{entry.customer_name}</td>
                    {/* <td className="type-column">
                      <span className={transactionType.className}>
                        {transactionType.label}
                      </span>
                    </td> */}
                    <td>
                      <strong>{entry.doc_no}</strong>
                    </td>
                    {/* <td>
                      <small>{entry.description}</small>
                    </td> */}
                    <td className="text-end">
                      {entry.debit > 0 && (
                        <span className="text-danger fw-bold">
                          ₹{entry.debit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                        </span>
                      )}
                    </td>
                    <td className="text-end">
                      {entry.credit > 0 && (
                        <span className="text-success fw-bold">
                          ₹{entry.credit.toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                        </span>
                      )}
                    </td>
                    <td className="text-end fw-bold">
                      <span className={entry.balanceCalc >= 0 ? 'text-danger' : 'text-success'}>
                        ₹{Math.abs(entry.balanceCalc).toLocaleString('en-IN', { minimumFractionDigits: 2 })}
                        {/* {entry.balanceCalc >= 0 ? ' Dr' : ' Cr'} */}
                      </span>
                    </td>
                  </tr>
                );
              })}

              {selectedCustomer && filteredLedger.length === 0 && (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <div className="text-muted">
                      <FaFileInvoice size={48} className="mb-3" />
                      <p>No transactions found for selected period</p>
                      <small>Try adjusting your date range</small>
                    </div>
                  </td>
                </tr>
              )}

              {/* {!selectedCustomer && (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    <div className="text-muted">
                      <FaUser size={48} className="mb-3" />
                      <p>Please select a customer to view ledger</p>
                    </div>
                  </td>
                </tr>
              )} */}
            </tbody>
            {filteredLedger.length > 0 && (
              <tfoot className="table-warning">
                {/* className="table-secondary fw-bold" */}
                <tr className="fw-bold">
                  <td colSpan="3" className="text-end">
                    TOTAL
                  </td>

                  <td className="text-end text-danger">
                    ₹{totals.totalDebit.toLocaleString('en-IN', {
                      minimumFractionDigits: 2
                    })}
                  </td>

                  <td className="text-end text-success">
                    ₹{totals.totalCredit.toLocaleString('en-IN', {
                      minimumFractionDigits: 2
                    })}
                  </td>

                  <td className="text-end">
                    <span className={netBalance >= 0 ? "text-danger" : "text-success"}>
                      ₹{Math.abs(netBalance).toLocaleString('en-IN', {
                        minimumFractionDigits: 2
                      })} {netBalance >= 0 ? " Dr" : " Cr"}

                    </span>
                  </td>
                </tr>
              </tfoot>

            )}

          </Table>
        </div>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </Container>
  );
};

export default CustomerWiseLedger;